import { gql } from "@apollo/client";

export const AddSubsidiary = gql`
  mutation AddSubsidiary(
    $token: String!
    $input: CreateAtsSubsidiaryInput!
    $customerID: ID!
    $companyID: ID!
    $user_details: SubscribedUser!
  ) {
    AddSubsidiary(
      token: $token
      input: $input
      customerID: $customerID
      companyID: $companyID
      user_details: $user_details
    ) {
      id
    }
  }
`;

export const UpdateSubsidiary = gql`
  mutation UpdateSubsidiary(
    $token: String!
    $subsidiaryID: ID!
    $input: UpdateAtsSubsidiaryInput!
    $user_details: SubscribedUser!
  ) {
    UpdateSubsidiary(
      token: $token
      input: $input
      subsidiaryID: $subsidiaryID
      user_details: $user_details
    ) {
      id
    }
  }
`;

export const AddSubsidiarySite = gql`
  mutation AddSubsidiarySite(
    $token: String!
    $input: CreateAtsSubsidiarySiteInput!
    $customerID: ID!
    $companyID: ID!
    $subsidiaryID: ID!
    $user_details: SubscribedUser!
  ) {
    AddSubsidiarySite(
      token: $token
      input: $input
      customerID: $customerID
      companyID: $companyID
      subsidiaryID: $subsidiaryID
      user_details: $user_details
    )
  }
`;

export const UpdateSubsidiarySite = gql`
  mutation UpdateSubsidiarySite(
    $token: String!
    $subsidiarySiteID: ID!
    $input: UpdateAtsSubsidiarySiteInput!
    $user_details: SubscribedUser!
  ) {
    UpdateSubsidiarySite(
      token: $token
      input: $input
      subsidiarySiteID: $subsidiarySiteID
      user_details: $user_details
    )
  }
`;

export const DeleteSubsidiary = gql`
  mutation DeleteSubsidiary(
    $token: String!
    $subsidiaryID: ID!
    $user_details: SubscribedUser!
  ) {
    DeleteSubsidiary(
      token: $token
      subsidiaryID: $subsidiaryID
      user_details: $user_details
    )
  }
`;

export const DeleteSubsidiarySite = gql`
  mutation DeleteSubsidiarySite(
    $token: String!
    $subsidiarySiteID: ID!
    $user_details: SubscribedUser!
  ) {
    DeleteSubsidiarySite(
      token: $token
      subsidiarySiteID: $subsidiarySiteID
      user_details: $user_details
    )
  }
`;

export const ImportSubsidiarySite = gql`
  mutation ImportSubsidiarySite(
    $token: String!
    $customerID: ID!
    $companyID: ID!
    $subsidiaryID: ID!
    $input: ImportSiteDetails!
    $user_details: SubscribedUser!
  ) {
    ImportSubsidiarySite(
      token: $token
      customerID: $customerID
      companyID: $companyID
      subsidiaryID: $subsidiaryID
      input: $input
      user_details: $user_details
    )
  }
`;

export const ExportSubsidiarySiteTemplate = gql`
  query ExportSubsidiarySiteTemplate(
    $token: String!
    $customerID: ID!
    $atSubsidiaryLevel: Boolean!
  ) {
    ExportSubsidiarySiteTemplate(
      token: $token
      customerID: $customerID
      atSubsidiaryLevel: $atSubsidiaryLevel
    )
  }
`;
